import humps from 'humps';

export let toCSSVars = (obj: Record<string, unknown>): string => {
  return Object.keys(obj).reduce((str, key) => {
    const formattedKey = humps.decamelize(key, { separator: '-' });

    return str.concat(`--${formattedKey}: ${obj[key]}; `);
  }, '');
};
